"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.flatConversations = void 0;
const flatConversations = (conversations) => {
    return conversations
        .flatMap((conversation) => Object.values(conversation))
        .map((flattedConversation) => flattedConversation[0]);
};
exports.flatConversations = flatConversations;
